import React from 'react'

import { Card, Grid } from '@softwaredev_cegeka/stix-core'

class FormLayout extends React.Component {
    getFormTitle() {
        const { entity, match, title } = this.props

        if (title) {
            return title
        }

        if (Object.keys(match.params).length > 0) {
            return `Edit ${entity}`
        } else {
            return `Create ${entity}`
        }
    }

    render() {
        return (
            <Grid.Container>
                <Grid.Row>
                    <Grid.Col md={{ span: 10, offset: 1 }}>
                        <div className="page-header" aria-label={'form-title'}>
                            <h1 className="content-title">
                                {this.getFormTitle()}
                            </h1>
                        </div>
                        <Card className="form-card">
                            <Card.Body>{this.props.children}</Card.Body>
                        </Card>
                    </Grid.Col>
                </Grid.Row>
            </Grid.Container>
        )
    }
}

export default FormLayout
